module.exports = __webpack_public_path__ + "static/preview-img4@2x-26187ee177dd665c661590bf16813d4c.png";